"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Progress = _interopRequireDefault(require("@/components/Progress"));
var _Detail = _interopRequireDefault(require("./Detail"));
var _kpiManagement = require("@/http/interface/sfe/kpiManagement");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** components */
/** services */
var _default2 = exports.default = {
  components: {
    Progress: _Progress.default,
    Detail: _Detail.default
  },
  props: {
    // 外部loading
    isLoading: {
      type: Boolean,
      default: false
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * ssbtypeOptions: [] // 店招品牌select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      /** 导入 */
      form: {
        file: null
      },
      isError: '',
      isShowModel: false,
      isShowProgress: false,
      excelBatchId: '',
      fileImportProcessUniqueCode: '',
      showClose: false,
      showResult: false,
      confirmText: null
    };
  },
  methods: {
    /** 传递外部数据 */uploadLoading: function uploadLoading(val) {
      this.$emit('update:isLoading', val);
    },
    // 导入
    uploadData: function uploadData(file) {
      var _this = this;
      // 数据状态初始化
      this.confirmText = this.$t('common.confirm');
      var rawFile = file.raw;
      if (!rawFile) return;
      if (rawFile.size > 100 * 1024 * 1024) {
        this.$message.error('The file size cannot exceed 100M');
        return;
      }
      // this.isLoading = true
      this.uploadLoading(true);
      var param = new FormData();
      param.append('file', rawFile);
      this.$api.taskAssignment.importTaskAllocated(param).then(function (res) {
        _this.isShowProgress = true;
        _this.excelBatchId = res.data.excelBatchId;
        _this.fileImportProcessUniqueCode = res.data.redisKey;
        _this.showClose = true;
        _this.$nextTick(function () {
          _this.$refs['progress'].start();
        });
      }).catch(function (err) {
        console.log(err);
      }).finally(function (res) {
        // this.isLoading = false
        _this.uploadLoading(false);
      });
    },
    handleError: function handleError() {
      this.confirmText = this.$t('common.checkResult');
    },
    handleClickConfirm: function handleClickConfirm() {
      if (this.confirmText === this.$t('common.checkResult')) {
        this.isShowProgress = false;
        this.isShowModel = true;
      } else {
        this.isShowProgress = false;
      }
    },
    handleEnd: function handleEnd() {
      // this.searchData()
      this.$emit('refresh');
    },
    downloadResultExcel: function downloadResultExcel(name) {
      var _this2 = this;
      var fileName = "".concat(name, "-").concat((0, _index.parseTime)(new Date().getTime()), "-").concat(this.$t('common.errorInfo'), ".xlsx");
      // this.isLoading = true
      this.uploadLoading(true);
      this.$api.common.downloadResultExcel(this.excelBatchId).then(function (res) {
        (0, _index.downloadFileExcel)(fileName, res.data, true);
      }).finally(function () {
        // this.isLoading = false
        _this2.uploadLoading(false);
      });
    }
  }
};